import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { useHasProductChanged } from "stores/product";
import { Button } from "components";
import { useTranslate } from "hooks";
import { useConfiguratorPopupContext } from "providers/ConfiguratorPopUpProvider";
import { getHomepage } from "utils";
import { useProject } from "stores/project";
import { toast } from "react-toastify";

export const BackToProjectButton = () => {
  const translate = useTranslate();
  const hasProductChanged = useHasProductChanged();
  const project = useProject();
  const { showConfiguratorPopup } = useConfiguratorPopupContext();

  const navigateToProjectConfigurator = useCallback(() => {
    const page = getHomepage()?.get("projectConfiguratorPage");
    if (!page) {
      toast.error(translate("PROJECT_CONFIGURATOR_NAVIGATE_TO_PROJECT_ERROR"));
      return;
    }
    Scrivito.navigateTo(page as Scrivito.Obj, {
      projectId: project?.id ?? null,
    });
  }, [project?.id, translate]);

  const handleNavigateBackToProject = useCallback(async () => {
    if (hasProductChanged) {
      showConfiguratorPopup(navigateToProjectConfigurator);
    } else {
      navigateToProjectConfigurator();
    }
  }, [hasProductChanged, navigateToProjectConfigurator, showConfiguratorPopup]);

  return (
    <Button
      data-testid="product-configurator-header_back-to-project-structure-btn"
      onClick={handleNavigateBackToProject}
    >
      {translate("PRODUCT_CONFIGURATOR_BACK_TO_PROJECT_STRUCTURE")}
    </Button>
  );
};
